<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div class="d-flex flex-column gap-8">
  <div id="header-container">
    <div>
      <h1 id="header-text">Program Code by Fuel Type Share of Propulsion Segment</h1>
    </div>
    <div>
      <button mat-flat-button color="primary" id="report-button" class="action-button"
              (click)="onRunReport()"
              [disabled]="isRunReportDisabled()">
        Run Report
      </button>
    </div>
  </div>

  <div class="year-range">
    <mat-form-field class="default-margin" subscriptSizing="dynamic">
      <mat-label class="asterisk--before">Start Year</mat-label>
      <mat-select [(ngModel)]="startYear" id="startYear">
        <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="default-margin" subscriptSizing="dynamic">
      <mat-label class="asterisk--before">End Year</mat-label>
      <mat-select [(ngModel)]="endYear" id="endYear">
        <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="default-margin content-height">
    <div class="table-title">
      <span>Available Scenarios</span>
    </div>
    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="availableScenarios"
      [columnDefs]="VEHICLE_PROPULSION_COLDEF"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      [postSortRows]="postSortRows"
      (selectionChanged)="onSelectionChanged($event)"
      (gridReady)="onGridReady($event)"
    />
  </div>
</div>
